import React, { useState } from "react";
import { Step, Modal } from "semantic-ui-react";
import { RutasDidacticasEditStep1, RutasDidacticasEditStep2 } from "./index";
import "./RutasDidacticasWizardedit.scss";

export function RutasDidacticasEditWizard({
  open,
  onClose,
  route,
  accessToken,
  onRefresh,
  teacher,
}) {
  const [activeStep, setActiveStep] = useState(1);
  // Almacena la ruta en edición (datos actualizados en Step1)
  const [updatedRoute, setUpdatedRoute] = useState(route);

  // Definición de los pasos (Step1, Step2)
  const steps = [
    {
      key: "editData",
      title: "Editar Datos",
      icon: "edit",
      active: activeStep === 1,
    },
    {
      key: "editAssistants",
      title: "Asistentes IA",
      icon: "users",
      active: activeStep === 2,
    },
  ];

  // Avanzar al Step2
  const goNext = () => {
    if (activeStep === 1) {
      setActiveStep(2);
    }
  };

  // Retroceder al Step1 (opcional)
  const goBack = () => {
    setActiveStep(1);
  };

  // Renderiza el contenido según el paso activo
  const renderContent = () => {
    // Si la ruta no existe aún, no renderizamos los pasos
    if (!updatedRoute) {
      return <div style={{ padding: "1rem" }}>Cargando ruta...</div>;
    }

    switch (activeStep) {
      case 1:
        return (
          <RutasDidacticasEditStep1
            route={updatedRoute}
            teacher={teacher}
            // Actualiza el estado local del wizard con los datos del formulario
            onUpdateRoute={(newData) =>
              setUpdatedRoute((prev) => ({ ...prev, ...newData }))
            }
            onClose={onClose}
            onNext={goNext}
          />
        );
      case 2:
        return (
          <RutasDidacticasEditStep2
            route={updatedRoute}
            accessToken={accessToken}
            onRefresh={onRefresh}
            onClose={onClose}
            onBack={goBack}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="large"
      closeIcon
      className="rutas-edit-wizard"
    >
      {/* Barra de pasos */}
      <div className="wizard-step-group">
        <Step.Group ordered items={steps} />
      </div>

      {renderContent()}
    </Modal>
  );
}
